import { Button, Typography } from 'mobily-ui-library/lib';
import { GlobalContext } from '../../context/GlobalContext';
import { useContext } from 'react';
import Modal from '../Modal/Modal';

import './ContactUsModal.scss';

interface Props {
    id?: string;
    rtl?: boolean;
    firstButtonText?: string;
    secondButtonText?: string;
    modalFirstButtonClick?: () => void;
    handleHeaderCancel?: () => void;
    title?: string;
    description?: string;
}
const win: any = window;
const serverUrl = win['base_portal_url'];

function ContactUsModal({ rtl, id, handleHeaderCancel, title, description, firstButtonText, secondButtonText, modalFirstButtonClick }: Props) {
    const { dispatch, state }: any = useContext(GlobalContext);
    const { orderInquiryErrRes } = state;

    const handleFirstClick = () => {
        if (id === 'notregistered') {
            dispatch({ type: 'UPDATE_PAGE', payload: 'TR_Login' });
        } else {
            dispatch({ type: 'RESET_DATA' })
            dispatch({ type: 'UPDATE_PAGE', payload: 'TR_Login' });
        }
        dispatch({ type: 'UPDATE_POPUP', payload: '' })
        if (modalFirstButtonClick) modalFirstButtonClick()
    }

    const handleSecondClick = () => {
        window.location.href = serverUrl + '/wps/portal/web/personal/am-overview/contact-us'
    }

    return (
        <Modal className={'ContactUs__Modal'} handleHeaderCancel={handleHeaderCancel} id={id} rtl={rtl} close={false}>
            <Typography rtl={rtl} className='Alert__title mb-2'>{title}</Typography>
            <Typography rtl={rtl} className={`Alert__subtitle ${orderInquiryErrRes?.StatusCode ? 'mb-2' : ''}`}>{description}</Typography>
            {orderInquiryErrRes?.StatusCode && (
                <Typography rtl={rtl} className='Alert__subtitle mb-4' fontFamily='ScandiaWeb-Bold, ExpoArabic-Bold'>
                    {(id === 'notregistered' || id === 'existingReq') ? '' : orderInquiryErrRes.StatusCode}
                </Typography>
            )}
            <Button rtl={rtl} className='Alert__Btn1' onClick={handleFirstClick}>{firstButtonText}</Button>
            {secondButtonText && <Button rtl={rtl} className='Alert__Btn2' onClick={handleSecondClick}>{secondButtonText}</Button>}
        </Modal>
    )
}

export default ContactUsModal